import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom"; 
import vagasWhite from "../../assets/vagasWhite.png";
import termo from "../../assets/termo.png";
import statisticsWhite from "../../assets/statisticsWhite.png";
import concessionBlue from "../../assets/concessionBlue.png";
import contrapartidaIconWhite from "../../assets/contrapartidaIconWhite.png";
import clipboardWhite from "../../assets/clipboardWhite.png";

const Container = styled.div`
  width: calc(80% - 300px); 
  margin-left: 20px;
  margin-top: 20px;
  background-color: #f9f9f9;

  @media (max-width: 768px) {
    margin-left: 150px; 
    width: calc(100% - 150px);
  }

  @media (max-width: 480px) {
    margin-left: 0; 
    width: 100%; 
  }
`;

const MessageContainer = styled.div`
  margin-bottom: 20px; 

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Message = styled.p`
  font-size: 15px;
  color: #555555;
  text-align: left;
  margin-bottom: 10px; 

  @media (max-width: 768px) {
    font-size: 14px;
    text-align: center;
  }
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding-top: 0;

  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const Button = styled.button`
  position: relative;
  width: 150px;
  height: 100px;
  padding: 0 5px;
  border: none;
  border-radius: 8px;
  background-color: #6AB8A8;
  color: white;
  font-size: 13px;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s ease, background-color 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #5ea89c;
  }

  &:disabled {
    background-color: #91bdb4;
    cursor: not-allowed;
    opacity: 0.72;
  }

  img {
    width: 40px;
    height: 40px;
    margin: 0 0 5px 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 768px) {
    width: 120px; 
    height: 80px; 
  }
`;

const ComingSoon = styled.span`
  position: absolute;
  top: 7px;
  right: 7px;
  padding: 2px 6px;
  border-radius: 8px;
  background: #ff9f1f;
  color: #ffffff;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.2;
`;

const buttons = [
  {
    id: "vagas",
    label: "Cadastrar Vagas",
    icon: vagasWhite,
    path: "/CadastrarVagasEstagio2",
  },
  // {
  //   id: "especialidades",
  //   label: "Cadastrar Especialidades",
  //   icon: especialities,
  //   path: "/CadastrarEspecialidades",
  // },
  {
    id: "concessao",
    label: "Concessão / Validações",
    icon: concessionBlue,
    path: "/Concessoes",
  },
  {
    id: "termo",
    label: "Termo de Compromisso",
    icon: termo,
    path: "/TermoCompromisso",
  },
  {
    id: "relatorio-concessao",
    label: "Relatórios de concessão",
    icon: statisticsWhite,
    path: "/RelatorioConcessao/campos-solicitados",
  },
  {
    id: "relatorio-atividades",
    label: "Relatórios de atividades",
    icon: clipboardWhite,
    disabled: true,
  },
  {
    id: "contrapartida",
    label: "Contrapartidas",
    icon: contrapartidaIconWhite,
    disabled: true,
  },
];

const DashboardContent = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <MessageContainer>
        <Message>
          Cadastre vagas de estágio no sistema e acompanhe as vagas disponibilizadas. Analise as
          solicitações das instituições de ensino e conceda vagas de estágio.
        </Message>
      </MessageContainer>

      <ButtonsWrapper>
        {buttons.map((btn) => (
          <Button
            key={btn.id}
            type="button"
            disabled={btn.disabled}
            aria-label={btn.disabled ? `${btn.label} — Em breve` : btn.label}
            onClick={() => btn.path && navigate(btn.path)}
          >
            {btn.disabled && <ComingSoon>Em breve</ComingSoon>}
            <img src={btn.icon} alt={btn.label} />
            {btn.label}
          </Button>
        ))}
      </ButtonsWrapper>
    </Container>
  );
};

export default DashboardContent;
